<script setup>
import Dialog from 'primevue/dialog'
import { computed, reactive, ref } from 'vue'
import axios from 'axios'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

const props = defineProps({
  mergeUrl: { type: String, default: null },
  actualDetails: { type: Array, default: null }
})

const emits = defineEmits(['post-succeed'])

// UI管理フラグ
const isLoading = ref(false)
const displayDialog = ref(false)
const displayResult = ref(false)

const formData = reactive({
  tax: 0,
  price: null,
  use_under24_format: false
})

const errorMessage = ref('')
const result = ref([])

const isSubmitActive = computed(() => {
  if (isLoading.value) return false
  if (formData.tax == null) return false
  if (formData.price == null) return false
  if (props.actualDetails.length < 2) return false

  return true
})

function closeAndReset() {
  displayDialog.value = false
  resetForm()
  displayResult.value = false
}

function resetForm() {
  formData.tax = 0
  formData.price = null
}

async function submit() {
  const url = props.mergeUrl
  const data = new FormData()
  data.append('tax', formData.tax)
  data.append('price', formData.price)
  data.append('use_under24_format', formData.use_under24_format)
  props.actualDetails.forEach((actualDetail) => {
    data.append('actual_detail_ids[]', actualDetail.id)
  })
  const headers = { 'content-type': 'multipart/form-data' }
  isLoading.value = true
  axios.defaults.headers.common['X-CSRF-Token'] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content')

  try {
    const res = await axios.post(url, data, { headers })
    isLoading.value = false
    displayResult.value = true
    result.value = res.data
    console.log(result.value) // 結果表示してないので一応ログだけ出してます
    emits('post-succeed')
  } catch (error) {
    console.error('リクエストでエラーが発生しました:', error)
    errorMessage.value = error.response.data.errors.join(' ')
    isLoading.value = false
  }
}

// 結果画面で上のボタン押して閉じた時
function onHide() {
  if (displayResult.value) {
    resetForm()
    displayResult.value = false
  }
}
</script>
<template>
  <div>
    <button
      class="group flex items-center justify-center rounded-md border border-gray-800 bg-white py-2 pl-3 pr-4 text-sm font-medium text-gray-800 shadow-sm hover:border-yellow-500 hover:bg-yellow-500 hover:text-white sm:w-auto"
      @click="displayDialog = true"
    >
      <div class="flex">作業の結合</div>
    </button>
    <Dialog
      v-model:visible="displayDialog"
      header="作業の結合"
      :modal="true"
      @hide="onHide"
    >
      <vue-element-loading :active="isLoading" />
      <div v-if="!displayResult">
        <div
          v-if="errorMessage"
          id="errors"
          class="mb-2 mt-2 rounded-md bg-red-50 p-4"
        >
          <div class="mt-2 text-sm text-red-700">エラー:{{ errorMessage }}</div>
        </div>
        <div class="mb-2">以下の作業を結合します</div>
        <div class="mb-2">
          <DataTable :value="actualDetails" style="font-size: 0.75rem">
            <Column field="title" header="案件名"></Column>
            <Column field="work_date" header="作業日"></Column>
            <Column field="actual_time.start" header="実績開始時刻"></Column>
            <Column field="actual_time.end" header="実績終了時刻"></Column>
          </DataTable>
        </div>

        <div class="mb-2">
          <span
            class="mx-2 inline-flex items-center rounded-md bg-gray-100 px-2.5 py-0.5 text-sm font-medium text-gray-800"
            >税率</span
          >
          <label v-for="n in [10, 8, 0]" :key="n">
            <input v-model="formData.tax" type="radio" name="tax" :value="n" />
            {{ n }}%
          </label>
        </div>
        <div class="mb-2">
          <span
            class="mx-2 inline-flex items-center rounded-md bg-gray-100 px-2.5 py-0.5 text-sm font-medium text-gray-800"
            >金額</span
          >
          <input
            v-model="formData.price"
            type="number"
            class="focus:outline-blue string mt-2 h-10 rounded border p-3 leading-normal"
          />
        </div>
        <div class="mb-2">
          <span
            class="mx-2 inline-flex items-center rounded-md bg-gray-100 px-2.5 py-0.5 text-sm font-medium text-gray-800"
            >当日に変更</span
          >
          <input
            v-model="formData.use_under24_format"
            type="checkbox"
            class=""
          />
        </div>
      </div>
      <div v-if="displayResult">
        <div
          v-if="errorMessage"
          id="errors"
          class="mb-2 mt-2 rounded-md bg-red-50 p-4"
        >
          <div class="mt-2 text-sm text-red-700">エラー:{{ errorMessage }}</div>
        </div>
        <div class="mb-2">作業を結合しました</div>
      </div>
      <template #footer>
        <button
          v-if="!displayResult"
          :disabled="!isSubmitActive"
          class="ml-6 rounded-md border border-transparent bg-yellow-500 px-8 py-1.5 font-medium text-white shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2"
          :class="{ 'cursor-not-allowed opacity-50': !isSubmitActive }"
          @click="submit"
        >
          結合
        </button>
        <button
          v-if="displayResult"
          class="ml-6 rounded-md border border-transparent bg-yellow-500 px-8 py-1.5 font-medium text-white shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:ring-offset-2"
          @click="closeAndReset"
        >
          OK
        </button>
      </template>
    </Dialog>
  </div>
</template>
